import { useEffect, useState } from 'react';
export const useOnLine = () => {
    const [onLine, setOnLine] = useState(window.navigator.onLine);
    useEffect(() => {
        const handleOnline = () => {
            setOnLine(true);
        };
        const handleOffline = () => {
            setOnLine(false);
        };
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    return onLine;
};
//# sourceMappingURL=useOnLine.js.map